const callbacks = new Map();

export const registerNotificationCallback = (id, callback) => {
  if (!id || typeof callback !== 'function') return id;
  callbacks.set(id, callback);
  return id;
};

export const invokeNotificationCallback = (id) => {
  const callback = callbacks.get(id);
  callbacks.delete(id);
  if (typeof callback === 'function') {
    callback();
  }
};

export const clearNotificationCallback = (id) => {
  if (id) callbacks.delete(id);
};
